// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"387":"7b0e8bcc","3411":"7b0e8bcc","3613":"7b0e8bcc","5905":"7b0e8bcc","7742":"71dcd781"}[chunkId] + ".chunk.css";
};